import React, { createContext, useContext, useState, useCallback } from 'react';

const translations = {
  tr: {
    // Login
    welcome: 'Hoş Geldiniz',
    signInDescription: 'CRM panelinize erişmek için giriş yapın',
    username: 'Kullanıcı Adı',
    password: 'Şifre',
    enterUsername: 'Kullanıcı adınızı girin',
    enterPassword: 'Şifrenizi girin',
    signIn: 'Giriş Yap',
    signingIn: 'Giriş yapılıyor...',
    
    // Navigation
    dashboard: 'Kontrol Paneli',
    leads: 'Müşteriler',
    findLeads: 'Müşteri Bul',
    orders: 'Siparişler',
    samples: 'Numuneler',
    shipments: 'Kargo Takip',
    products: 'Ürünler',
    productVideos: 'Ürün Videoları',
    specifications: 'Spesifikasyonlar',
    recipes: 'Reçeteler',
    routePlanner: 'Rota Planlayıcı',
    dailyReports: 'Günlük Raporlar',
    expenses: 'Giderler & Faturalar',
    // Expenses translations
    expensesTitle: 'Giderler & Faturalar',
    totalExpense: 'Toplam Gider',
    hotel: 'Otel',
    creditCard: 'Kredi Kartı',
    dkv: 'DKV',
    otherExpenses: 'Diğer Giderler',
    newFolder: 'Yeni Klasör',
    excel: 'Excel',
    report: 'Rapor',
    monthlyReport: 'Aylık Rapor',
    yearlyReport: 'Yıllık Rapor',
    allExpenses: 'Tüm Giderler',
    mergePdf: 'PDF Birleştir',
    scanInvoice: 'Fatura Tara',
    uploadPdf: 'PDF Yükle',
    allMonths: 'Tüm Aylar',
    allCategories: 'Tüm Kategoriler',
    searchExpense: 'Gider ara...',
    noExpensesYet: 'Henüz gider yok',
    folderName: 'Klasör Adı',
    parentFolder: 'Üst Klasör',
    rootFolder: 'Ana Dizin (Kök)',
    createFolder: 'Oluştur',
    cancel: 'İptal',
    category: 'Kategori',
    checkIn: 'Check-In',
    checkOut: 'Check-Out',
    nights: 'Gece Sayısı',
    hotelName: 'Otel Adı',
    amount: 'Tutar',
    country: 'Ülke',
    address: 'Adres',
    description: 'Açıklama',
    notes: 'Notlar',
    upload: 'Yükle',
    uploading: 'Yükleniyor...',
    view: 'Görüntüle',
    download: 'İndir',
    delete: 'Sil',
    moveToFolder: 'Klasöre Taşı',
    removeFromFolder: 'Klasörden Çıkar',
    excelDownloaded: 'Excel indirildi',
    reportDownloaded: 'Rapor indirildi',
    pdfsMerged: 'PDF\'ler birleştirildi',
    noPdfsToMerge: 'Birleştirilecek PDF yok',
    foodFairs: 'Gıda Fuarları',
    templates: 'Şablonlar',
    mail: 'Gewürzberg E-Mail',
    gewuerzbergMail: 'Gewürzberg Mail',
    mailInbox: 'Gewürzberg E-Mail',
    aiMailComposer: 'AI ile Mail Yaz',
    aiAnalytics: 'AI Analiz',
    customerSegments: 'Müşteri Segmentleri',
    emailComposer: 'Mail Oluştur',
    emailHistory: 'Mail Geçmişi',
    settings: 'Ayarlar',
    admin: 'Kullanıcı Yönetimi',
    language: 'Dil',
    logout: 'Çıkış',
    signature: 'İmza',
    
    // Dashboard
    totalLeads: 'Toplam Müşteri',
    customerDetails: 'Müşteri Detayları',
    totalOrders: 'Toplam Sipariş',
    emailsSent: 'Gönderilen Mail',
    emailsFailed: 'Başarısız Mail',
    recentLeads: 'Son Eklenen Müşteriler',
    recentEmails: 'Son Mailler',
    noLeadsYet: 'Henüz müşteri yok',
    recentShipments: 'Son Kargolar',
    welcomeTo: 'Hoş geldiniz',
    revenue: 'Gelir',
    yearlyTarget: 'Yıllık Hedef',
    targetProgress: 'Hedef İlerlemesi',
    noTarget: 'Hedef belirlenmedi',
    calendar: 'Takvim',
    todaysAgenda: 'Bugünün Gündemi',
    noEventsToday: 'Bugün etkinlik yok',
    addEvent: 'Etkinlik Ekle',
    salesForecast: 'Satış Tahmini',
    generateForecast: 'Tahmin Oluştur',
    churnAnalysis: 'Kayıp Analizi',
    atRiskCustomers: 'Risk Altındaki Müşteriler',
    noAtRisk: 'Risk altında müşteri yok',
    analyzeChurn: 'Kayıp Analizi Yap',
    allTime: 'Tüm Zamanlar',
    oneMonth: '1 Ay',
    threeMonths: '3 Ay',
    sixMonths: '6 Ay',
    oneYear: '1 Yıl',
    scheduleVisit: 'Ziyaret Planla',
    salesOverview: 'Satış Özeti',
    customerHealth: 'Müşteri Sağlığı',
    quickActions: 'Hızlı İşlemler',
    newOrder: 'Yeni Sipariş',
    newLead: 'Yeni Müşteri',
    sendMail: 'Mail Gönder',
    viewAll: 'Tümünü Gör',
    activeShipments: 'Aktif Kargolar',
    pendingOrders: 'Bekleyen Siparişler',
    thisMonth: 'Bu Ay',
    lastMonth: 'Geçen Ay',
    growth: 'Büyüme',
    healthy: 'Sağlıklı',
    atRisk: 'Risk Altında',
    critical: 'Kritik',
    title: 'Başlık',
    time: 'Saat',
    customer: 'Müşteri',
    optional: 'İsteğe Bağlı',
    selectCustomer: 'Müşteri seçin...',
    noCustomer: 'Müşteri yok',
    additionalNotes: 'Ek notlar...',
    pleaseEnterTitle: 'Lütfen bir başlık girin',
    recentShipments: 'Son Kargolar',
    topCustomers: 'En Değerli Müşteriler',
    financialSummary: 'Finansal Özet',
    totalRevenue: 'Toplam Ciro',
    paid: 'Ödenen',
    pendingPayment: 'Bekleyen',
    paymentRate: 'Ödeme Oranı',
    annualTarget: 'Yıllık Hedef',
    completed: 'tamamlandı',
    predictedRevenue: 'Tahmin Edilen Gelir',
    topFactor: 'Ana Faktör',
    recommendation: 'Öneri',
    
    // Bulk Operations
    bulkEmail: 'Toplu Email',
    selected: 'Seçili',
    sendingEmail: 'Gönderiliyor...',
    addOrder: 'Sipariş Ekle',
    searchOrders: 'Sipariş ara...',
    noOrdersYet: 'Henüz sipariş yok',
    selectCustomer: 'Müşteri seçin',
    orderNotes: 'Sipariş notları...',
    donerNews: 'Döner & Kebab Haberleri',
    sendOrderByEmail: 'Siparişi Mail ile Gönder',
    sendOrderEmailDescription: 'Sipariş PDF\'ini istediğiniz e-posta adresine gönderin',
    emailSubjectPlaceholder: 'Mail konusu',
    emailLanguage: 'E-posta Dili',
    send: 'Gönder',
    cancel: 'İptal',
    
    // Activity
    activityHistory: 'Aktivite Geçmişi',
    newActivity: 'Yeni Aktivite Ekle',
    allActivities: 'Tüm görüşme ve ziyaret geçmişi',
    activityType: 'Aktivite Türü',
    
    // Activity Types
    call: 'Telefon',
    visit: 'Ziyaret',
    email: 'E-posta',
    order: 'Sipariş',
    note: 'Not',
    followUp: 'Takip',
    sampleTested: 'Numune Test Edildi',
    result: 'Sonuç',
    positive: 'Olumlu',
    negative: 'Olumsuz',
    neutral: 'Nötr',
    postponed: 'Ertelendi',
    noAnswer: 'Cevap Vermedi',
    whatWasDiscussed: 'Ne konuşuldu? Ne oldu?',
    nextActionDate: 'Sonraki Aksiyon Tarihi',
    nextActionNote: 'Sonraki Aksiyon Notu',
    whatToDo: 'Ne yapılacak?',
    
    // Customer Status
    ordered: 'Sipariş Verdi',
    pending: 'Beklemede',
    confirmed: 'Onaylandı',
    
    // Admin
    addUser: 'Kullanıcı Ekle',
    editUser: 'Kullanıcı Düzenle',
    newUser: 'Yeni Kullanıcı',
    user: 'Kullanıcı',
    users: 'kullanıcı',
    enterUserInfo: 'Kullanıcı bilgilerini girin',
    fullName: 'Ad Soyad',
    
    // Import/Export
    importToLeads: 'Müşterilere Aktar',
    addToLeads: 'Seçilenleri Ekle',
    
    // Event Types
    customerVisit: 'Müşteri Ziyareti',
    meeting: 'Toplantı',
    phoneCall: 'Telefon Görüşmesi',
    delivery: 'Teslimat',
    task: 'Görev',
    
    // Leads
    addLead: 'Müşteri Ekle',
    addNewLead: 'Veritabanınıza yeni müşteri ekleyin',
    updateLeadInfo: 'Müşteri bilgilerini güncelleyin',
    editLead: 'Müşteri Düzenle',
    deleteLead: 'Müşteri Sil',
    firstName: 'Ad',
    lastName: 'Soyad',
    companyName: 'Firma Adı',
    taxNumber: 'Vergi Numarası',
    address: 'Adres',
    email: 'E-posta',
    phone: 'Telefon',
    city: 'Şehir',
    country: 'Ülke',
    notes: 'Notlar',
    actions: 'İşlemler',
    save: 'Kaydet',
    cancel: 'İptal',
    delete: 'Sil',
    edit: 'Düzenle',
    sendEmail: 'Mail Gönder',
    confirmDelete: 'Bu öğeyi silmek istediğinize emin misiniz?',
    viewDetails: 'Detayları Gör',
    downloadPdf: 'PDF İndir',
    bulkEmail: 'Toplu Mail',
    selectedItems: 'Seçili Öğe',
    selectAll: 'Tümünü Seç',
    deselectAll: 'Seçimi Kaldır',
    
    // Products & Videos
    addProduct: 'Ürün Ekle',
    editProduct: 'Ürün Düzenle',
    productName: 'Ürün Adı',
    productCode: 'Ürün Kodu',
    unit: 'Birim',
    price: 'Fiyat',
    description: 'Açıklama',
    uploadVideo: 'Video Yükle',
    dragDropVideo: 'Videoyu buraya sürükleyin veya tıklayın',
    sendViaWhatsApp: 'WhatsApp ile Gönder',
    sendViaEmail: 'Mail ile Gönder',
    productVideo: 'Ürün Videosu',
    videoTitle: 'Video Başlığı',
    videoDescription: 'Açıklama',
    noVideos: 'Henüz video yok',
    noProducts: 'Henüz ürün yok',
    
    // Mail Inbox
    inbox: 'Gelen Kutusu',
    sent: 'Gönderilenler',
    drafts: 'Taslaklar',
    starred: 'Yıldızlı',
    trash: 'Çöp Kutusu',
    spam: 'Spam',
    allMail: 'Tüm Mailler',
    compose: 'Yeni Mail',
    from: 'Kimden',
    to: 'Kime',
    subject: 'Konu',
    date: 'Tarih',
    noEmails: 'Henüz mail yok',
    reply: 'Yanıtla',
    replyAll: 'Tümünü Yanıtla',
    forward: 'İlet',
    markAsRead: 'Okundu İşaretle',
    markAsUnread: 'Okunmadı İşaretle',
    moveTo: 'Taşı',
    archive: 'Arşivle',
    refresh: 'Yenile',
    attachment: 'Ek',
    attachments: 'Ekler',
    addAttachment: 'Ek Ekle',
    sendNow: 'Şimdi Gönder',
    saveDraft: 'Taslak Kaydet',
    discard: 'Vazgeç',
    cc: 'CC',
    bcc: 'BCC',
    unread: 'Okunmamış',
    important: 'Önemli',
    // Mail Extended
    mailCenter: 'E-Mail Merkezi',
    newMail: 'Yeni Mail',
    signatureSettings: 'İmza Ayarları',
    emailSettings: 'Email Ayarları',
    connectionError: 'Bağlantı Hatası',
    configureImap: 'Ayarlar → IMAP/SMTP yapılandırın',
    inboxEmpty: 'Gelen kutunuz boş',
    noSentMails: 'Henüz mail göndermediniz',
    noDrafts: 'Taslak yok',
    noStarred: 'Yıldızlı mail yok',
    trashEmpty: 'Çöp kutusu boş',
    loadingMails: 'Mailler yükleniyor...',
    mailsUpdated: 'Mailler güncellendi',
    couldNotLoadMails: 'Mailler yüklenemedi',
    movedToTrash: 'Mail çöp kutusuna taşındı',
    signatureSaved: 'İmza kaydedildi',
    signatureNotSaved: 'İmza kaydedilemedi',
    settingsSaved: 'Ayarlar kaydedildi',
    settingsNotSaved: 'Ayarlar kaydedilemedi',
    recipientSubjectRequired: 'Alıcı ve konu gerekli',
    mailSent: 'Mail gönderildi',
    mailServerUnavailable: 'Mail sunucusu geçici kullanılamıyor. Taslak olarak kaydedildi.',
    // AI Mail Features
    aiAssistant: 'AI Asistan',
    aiSummaryAndReply: 'AI Özet & Hızlı Yanıt',
    analyzing: 'Analiz ediliyor...',
    quickReplies: 'Hızlı Yanıtlar',
    translateToTr: 'Türkçe\'ye Çevir',
    translateToEn: 'İngilizce\'ye Çevir',
    translateToDe: 'Almanca\'ya Çevir',
    translation: 'Çeviri',
    translating: 'Çevriliyor...',
    translationFailed: 'Çeviri yapılamadı',
    aiHelper: 'AI Yardımcı',
    writeWithAi: 'AI ile Yaz',
    improve: 'İyileştir',
    shorten: 'Kısalt',
    expand: 'Genişlet',
    formalize: 'Resmileştir',
    whatToWrite: 'Ne yazmak istiyorsunuz?',
    aiWriteHint: 'Örn: Müşteriye sipariş gecikmesi hakkında özür dileyen bir mail yaz',
    tone: 'Üslup',
    professional: 'Profesyonel',
    friendly: 'Samimi',
    formal: 'Resmi',
    generate: 'Oluştur',
    emailGenerated: 'E-posta oluşturuldu',
    couldNotGenerate: 'E-posta oluşturulamadı',
    textImproved: 'Metin iyileştirildi',
    couldNotImprove: 'İyileştirme yapılamadı',
    writeTextFirst: 'Önce bir metin yazın',
    specifyRequest: 'Lütfen ne yazmak istediğinizi belirtin',
    addImage: 'Görsel Ekle',
    imageHint: 'Logo veya imza görseli ekleyebilirsiniz',
    emailSignature: 'E-posta İmzası',
    senderInfo: 'Gönderici Bilgileri',
    senderName: 'Gönderici Adı',
    senderEmail: 'Gönderici E-posta',
    imapSettings: 'IMAP Ayarları (Gelen Kutusu)',
    imapServer: 'IMAP Sunucusu',
    imapPort: 'IMAP Port',
    smtpSettings: 'SMTP Ayarları (Giden Kutusu)',
    smtpServer: 'SMTP Sunucusu',
    smtpPort: 'SMTP Port',
    username: 'Kullanıcı Adı',
    password: 'Şifre',
    settingsNote: 'IMAP/SMTP ayarlarını email sağlayıcınızdan (1&1 IONOS, Gmail, vb.) alabilirsiniz.',
    filesAdded: 'dosya eklendi',
    noSubject: '(Konu yok)',
    noContent: 'İçerik yok',
    loading: 'Yükleniyor...',
    mail: 'mail',
    replyMessage: 'Yanıtla',
    forwardMessage: 'İlet',
    newMessage: 'Yeni Mesaj',
    // Pagination
    page: 'Sayfa',
    previous: 'Önceki',
    next: 'Sonraki',
    // Folders
    folders: 'Klasörler',
    addFolder: 'Klasör Ekle',
    folderName: 'Klasör Adı',
    createFolder: 'Klasör Oluştur',
    deleteFolder: 'Klasör Sil',
    customFolders: 'Özel Klasörler',
    // AI Analysis Features
    spamAnalysis: 'Spam Analizi',
    customerRecognition: 'Müşteri Tanıma',
    sentimentAnalysis: 'Duygu Analizi',
    analyzingSpam: 'Spam kontrolü yapılıyor...',
    notSpam: 'Spam değil',
    possibleSpam: 'Olası spam',
    definitelySpam: 'Kesinlikle spam',
    recognizingCustomer: 'Müşteri tanınıyor...',
    customerFound: 'Müşteri bulundu',
    customerNotFound: 'Müşteri bulunamadı',
    analyzingSentiment: 'Duygu analizi yapılıyor...',
    positive: 'Olumlu',
    negative: 'Olumsuz',
    neutral: 'Nötr',
    urgent: 'Acil',
    fullScreen: 'Tam Ekran',
    exitFullScreen: 'Tam Ekrandan Çık',
    
    // Templates
    addTemplate: 'Şablon Ekle',
    templateName: 'Şablon Adı',
    body: 'İçerik',
    noTemplates: 'Henüz şablon yok',
    
    // Email Composer
    selectLead: 'Müşteri Seç',
    selectTemplate: 'Şablon Seç',
    generateWithAI: 'AI ile Oluştur',
    generating: 'Oluşturuluyor...',
    send: 'Gönder',
    preview: 'Önizleme',
    orderDetails: 'Sipariş Detayları',
    customerInfo: 'Müşteri Bilgileri',
    product: 'Ürün',
    emailSubject: 'Mail Konusu',
    emailBody: 'Mail İçeriği',
    tone: 'Ton',
    professional: 'Profesyonel',
    friendly: 'Samimi',
    formal: 'Resmi',
    
    // Email History
    recipient: 'Alıcı',
    company: 'Firma',
    status: 'Durum',
    sentAt: 'Gönderim Zamanı',
    failed: 'Başarısız',
    noEmailHistory: 'Henüz mail geçmişi yok',
    
    // Settings
    companySettings: 'Şirket Ayarları',
    smtpSettings: 'SMTP Ayarları',
    imapSettings: 'IMAP Ayarları',
    smtpHost: 'SMTP Sunucusu',
    imapHost: 'IMAP Sunucusu',
    smtpPort: 'SMTP Port',
    imapPort: 'IMAP Port',
    smtpUsername: 'Kullanıcı Adı',
    smtpPassword: 'Şifre',
    fromEmail: 'Gönderen E-posta',
    fromName: 'Gönderen Adı',
    useTLS: 'TLS Kullan',
    useSSL: 'SSL Kullan',
    testConnection: 'Bağlantıyı Test Et',
    saveSettings: 'Ayarları Kaydet',
    
    // Orders
    order: 'Sipariş',
    orderDate: 'Sipariş Tarihi',
    quantity: 'Miktar',
    unitPrice: 'Birim Fiyat',
    pending: 'Beklemede',
    confirmed: 'Onaylandı',
    shipped: 'Gönderildi',
    delivered: 'Teslim Edildi',
    cancelled: 'İptal',
    addOrder: 'Sipariş Ekle',
    editOrder: 'Sipariş Düzenle',
    deleteOrder: 'Siparişi Sil',
    noOrders: 'Henüz sipariş yok',
    products: 'Ürünler',
    pieces: 'Adet',
    selectFromSaved: 'Kayıtlı Ürünlerden Seç',
    selectProduct: 'Ürün seç (opsiyonel)',
    updateOrderInfo: 'Sipariş bilgilerini güncelleyin',
    addMultipleProducts: 'Birden fazla ürün ekleyebilirsiniz',
    saving: 'Kaydediliyor...',
    
    // Shipments
    trackingNumber: 'Takip Numarası',
    carrier: 'Kargo Firması',
    shipmentStatus: 'Kargo Durumu',
    addShipment: 'Kargo Ekle',
    noShipments: 'Henüz kargo yok',
    trackShipment: 'Kargo Takip Et',
    
    // Recipes
    addRecipe: 'Reçete Ekle',
    recipeName: 'Reçete Adı',
    ingredients: 'Malzemeler',
    instructions: 'Talimatlar',
    noRecipes: 'Henüz reçete yok',
    
    // Specifications
    addSpecification: 'Spesifikasyon Ekle',
    noSpecifications: 'Henüz spesifikasyon yok',
    
    // Daily Reports
    addReport: 'Rapor Ekle',
    reportDate: 'Rapor Tarihi',
    reportContent: 'Rapor İçeriği',
    noReports: 'Henüz rapor yok',
    
    // Route Planner
    planRoute: 'Rota Planla',
    optimizeRoute: 'Rotayı Optimize Et',
    startPoint: 'Başlangıç Noktası',
    endPoint: 'Bitiş Noktası',
    waypoints: 'Ara Noktalar',
    
    // Lead Finder
    searchLeads: 'Müşteri Ara',
    searchCountry: 'Ülke',
    searchCity: 'Şehir',
    businessType: 'İş Türü',
    searchResults: 'Arama Sonuçları',
    noResultsFound: 'Sonuç bulunamadı',
    addToLeads: 'Müşterilere Ekle',
    
    // Messages
    leadAdded: 'Müşteri eklendi',
    leadUpdated: 'Müşteri güncellendi',
    leadDeleted: 'Müşteri silindi',
    templateAdded: 'Şablon eklendi',
    templateDeleted: 'Şablon silindi',
    emailSent: 'Mail gönderildi',
    emailQueued: 'Mail kuyruğa eklendi',
    settingsSaved: 'Ayarlar kaydedildi',
    connectionSuccess: 'Bağlantı başarılı',
    connectionFailed: 'Bağlantı başarısız',
    error: 'Hata',
    success: 'Başarılı',
    loading: 'Yükleniyor...',
    search: 'Ara',
    noResults: 'Sonuç bulunamadı',
    
    // Common
    all: 'Tümü',
    today: 'Bugün',
    yesterday: 'Dün',
    thisWeek: 'Bu Hafta',
    thisMonth: 'Bu Ay',
    download: 'İndir',
    upload: 'Yükle',
    share: 'Paylaş',
    view: 'Görüntüle',
    close: 'Kapat',
    back: 'Geri',
    next: 'İleri',
    previous: 'Önceki',
    confirm: 'Onayla',
    yes: 'Evet',
    no: 'Hayır',
    or: 'veya',
    and: 've',
    of: '/',
    items: 'öğe',
    page: 'Sayfa',
    showing: 'Gösterilen',
    results: 'sonuç',
    total: 'Toplam',
    details: 'Detaylar',
    information: 'Bilgi',
    warning: 'Uyarı',
    required: 'Zorunlu',
    optional: 'İsteğe Bağlı',
    notConfigured: 'Yapılandırılmadı',
    configureNow: 'Şimdi Yapılandır',
    pleaseWait: 'Lütfen bekleyin...',
    somethingWentWrong: 'Bir şeyler yanlış gitti',
    tryAgain: 'Tekrar Dene',
    goBack: 'Geri Dön',
  },
  de: {
    // Login
    welcome: 'Willkommen',
    signInDescription: 'Melden Sie sich an, um auf Ihr CRM-Dashboard zuzugreifen',
    username: 'Benutzername',
    password: 'Passwort',
    enterUsername: 'Benutzername eingeben',
    enterPassword: 'Passwort eingeben',
    signIn: 'Anmelden',
    signingIn: 'Anmeldung läuft...',
    
    // Navigation
    dashboard: 'Dashboard',
    leads: 'Kunden',
    findLeads: 'Kunden finden',
    orders: 'Bestellungen',
    samples: 'Muster',
    shipments: 'Sendungsverfolgung',
    products: 'Produkte',
    productVideos: 'Produktvideos',
    specifications: 'Spezifikationen',
    recipes: 'Rezepte',
    routePlanner: 'Routenplaner',
    dailyReports: 'Tagesberichte',
    expenses: 'Ausgaben & Rechnungen',
    // Expenses translations
    expensesTitle: 'Ausgaben & Rechnungen',
    totalExpense: 'Gesamtausgaben',
    hotel: 'Hotel',
    creditCard: 'Kreditkarte',
    dkv: 'DKV',
    otherExpenses: 'Sonstige Ausgaben',
    newFolder: 'Neuer Ordner',
    excel: 'Excel',
    report: 'Bericht',
    monthlyReport: 'Monatsbericht',
    yearlyReport: 'Jahresbericht',
    allExpenses: 'Alle Ausgaben',
    mergePdf: 'PDF zusammenführen',
    scanInvoice: 'Rechnung scannen',
    uploadPdf: 'PDF hochladen',
    allMonths: 'Alle Monate',
    allCategories: 'Alle Kategorien',
    searchExpense: 'Ausgabe suchen...',
    noExpensesYet: 'Noch keine Ausgaben',
    folderName: 'Ordnername',
    parentFolder: 'Übergeordneter Ordner',
    rootFolder: 'Stammverzeichnis',
    createFolder: 'Erstellen',
    cancel: 'Abbrechen',
    category: 'Kategorie',
    checkIn: 'Check-In',
    checkOut: 'Check-Out',
    nights: 'Nächte',
    hotelName: 'Hotelname',
    amount: 'Betrag',
    country: 'Land',
    address: 'Adresse',
    description: 'Beschreibung',
    notes: 'Notizen',
    upload: 'Hochladen',
    uploading: 'Wird hochgeladen...',
    view: 'Anzeigen',
    download: 'Herunterladen',
    delete: 'Löschen',
    moveToFolder: 'In Ordner verschieben',
    removeFromFolder: 'Aus Ordner entfernen',
    excelDownloaded: 'Excel heruntergeladen',
    reportDownloaded: 'Bericht heruntergeladen',
    pdfsMerged: 'PDFs zusammengeführt',
    noPdfsToMerge: 'Keine PDFs zum Zusammenführen',
    foodFairs: 'Lebensmittelmessen',
    templates: 'Vorlagen',
    mail: 'Gewürzberg E-Mail',
    gewuerzbergMail: 'Gewürzberg Mail',
    mailInbox: 'Gewürzberg Posteingang',
    aiMailComposer: 'KI E-Mail schreiben',
    aiAnalytics: 'KI Analyse',
    customerSegments: 'Kundensegmente',
    emailComposer: 'E-Mail erstellen',
    emailHistory: 'E-Mail-Verlauf',
    settings: 'Einstellungen',
    admin: 'Benutzerverwaltung',
    language: 'Sprache',
    logout: 'Abmelden',
    signature: 'Signatur',
    
    // Dashboard
    totalLeads: 'Gesamtkunden',
    customerDetails: 'Kundendetails',
    totalOrders: 'Gesamtbestellungen',
    emailsSent: 'Gesendete E-Mails',
    emailsFailed: 'Fehlgeschlagene E-Mails',
    recentLeads: 'Neueste Kunden',
    noLeadsYet: 'Noch keine Kunden',
    recentShipments: 'Letzte Sendungen',
    welcomeTo: 'Willkommen bei',
    revenue: 'Umsatz',
    yearlyTarget: 'Jahresziel',
    targetProgress: 'Zielfortschritt',
    noTarget: 'Kein Ziel festgelegt',
    calendar: 'Kalender',
    todaysAgenda: 'Heutige Agenda',
    noEventsToday: 'Heute keine Termine',
    addEvent: 'Termin hinzufügen',
    salesForecast: 'Verkaufsprognose',
    generateForecast: 'Prognose erstellen',
    churnAnalysis: 'Abwanderungsanalyse',
    atRiskCustomers: 'Gefährdete Kunden',
    noAtRisk: 'Keine gefährdeten Kunden',
    analyzeChurn: 'Abwanderung analysieren',
    allTime: 'Alle Zeit',
    oneMonth: '1 Monat',
    threeMonths: '3 Monate',
    sixMonths: '6 Monate',
    oneYear: '1 Jahr',
    scheduleVisit: 'Besuch planen',
    salesOverview: 'Verkaufsübersicht',
    customerHealth: 'Kundenstatus',
    quickActions: 'Schnellaktionen',
    newOrder: 'Neue Bestellung',
    newLead: 'Neuer Kunde',
    sendMail: 'E-Mail senden',
    viewAll: 'Alle anzeigen',
    activeShipments: 'Aktive Sendungen',
    pendingOrders: 'Ausstehende Bestellungen',
    thisMonth: 'Dieser Monat',
    lastMonth: 'Letzter Monat',
    growth: 'Wachstum',
    healthy: 'Gesund',
    atRisk: 'Gefährdet',
    critical: 'Kritisch',
    title: 'Titel',
    time: 'Zeit',
    customer: 'Kunde',
    optional: 'Optional',
    selectCustomer: 'Kunde auswählen...',
    noCustomer: 'Kein Kunde',
    additionalNotes: 'Zusätzliche Notizen...',
    pleaseEnterTitle: 'Bitte geben Sie einen Titel ein',
    recentShipments: 'Letzte Sendungen',
    topCustomers: 'Top-Kunden',
    financialSummary: 'Finanzübersicht',
    totalRevenue: 'Gesamtumsatz',
    paid: 'Bezahlt',
    pendingPayment: 'Ausstehend',
    paymentRate: 'Zahlungsrate',
    annualTarget: 'Jahresziel',
    completed: 'abgeschlossen',
    predictedRevenue: 'Prognostizierter Umsatz',
    topFactor: 'Hauptfaktor',
    recommendation: 'Empfehlung',
    
    // Bulk Operations
    bulkEmail: 'Massen-E-Mail',
    selected: 'Ausgewählt',
    sendingEmail: 'Wird gesendet...',
    addOrder: 'Bestellung hinzufügen',
    searchOrders: 'Bestellungen suchen...',
    noOrdersYet: 'Noch keine Bestellungen',
    selectCustomer: 'Kunde auswählen',
    orderNotes: 'Bestellnotizen...',
    donerNews: 'Döner & Kebab Nachrichten',
    sendOrderByEmail: 'Bestellung per E-Mail senden',
    sendOrderEmailDescription: 'Senden Sie die Bestell-PDF an die gewünschte E-Mail-Adresse',
    emailSubjectPlaceholder: 'E-Mail Betreff',
    emailLanguage: 'E-Mail Sprache',
    send: 'Senden',
    cancel: 'Abbrechen',
    
    // Activity
    activityHistory: 'Aktivitätsverlauf',
    newActivity: 'Neue Aktivität hinzufügen',
    allActivities: 'Alle Gespräche und Besuche',
    activityType: 'Aktivitätstyp',
    
    // Activity Types
    call: 'Anruf',
    visit: 'Besuch',
    email: 'E-Mail',
    order: 'Bestellung',
    note: 'Notiz',
    followUp: 'Nachverfolgung',
    sampleTested: 'Probe Getestet',
    result: 'Ergebnis',
    positive: 'Positiv',
    negative: 'Negativ',
    neutral: 'Neutral',
    postponed: 'Verschoben',
    noAnswer: 'Keine Antwort',
    whatWasDiscussed: 'Was wurde besprochen?',
    nextActionDate: 'Nächstes Aktionsdatum',
    nextActionNote: 'Nächste Aktionsnotiz',
    whatToDo: 'Was zu tun?',
    
    // Customer Status
    ordered: 'Bestellt',
    pending: 'Ausstehend',
    confirmed: 'Bestätigt',
    
    // Admin
    addUser: 'Benutzer hinzufügen',
    editUser: 'Benutzer bearbeiten',
    newUser: 'Neuer Benutzer',
    user: 'Benutzer',
    users: 'Benutzer',
    enterUserInfo: 'Benutzerinformationen eingeben',
    fullName: 'Vollständiger Name',
    
    // Import/Export
    importToLeads: 'Zu Kunden importieren',
    addToLeads: 'Ausgewählte hinzufügen',
    
    // Event Types
    customerVisit: 'Kundenbesuch',
    meeting: 'Besprechung',
    phoneCall: 'Telefonat',
    delivery: 'Lieferung',
    task: 'Aufgabe',
    
    // Leads
    addLead: 'Kunde hinzufügen',
    addNewLead: 'Neuen Kunden zur Datenbank hinzufügen',
    updateLeadInfo: 'Kundeninformationen aktualisieren',
    editLead: 'Kunde bearbeiten',
    deleteLead: 'Kunde löschen',
    firstName: 'Vorname',
    lastName: 'Nachname',
    companyName: 'Firmenname',
    taxNumber: 'Steuernummer',
    address: 'Adresse',
    email: 'E-Mail',
    phone: 'Telefon',
    city: 'Stadt',
    country: 'Land',
    notes: 'Notizen',
    actions: 'Aktionen',
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    sendEmail: 'E-Mail senden',
    confirmDelete: 'Möchten Sie dieses Element wirklich löschen?',
    viewDetails: 'Details anzeigen',
    downloadPdf: 'PDF herunterladen',
    bulkEmail: 'Massen-E-Mail',
    selectedItems: 'Ausgewählte Elemente',
    selectAll: 'Alle auswählen',
    deselectAll: 'Auswahl aufheben',
    
    // Products & Videos
    addProduct: 'Produkt hinzufügen',
    editProduct: 'Produkt bearbeiten',
    productName: 'Produktname',
    productCode: 'Produktcode',
    unit: 'Einheit',
    price: 'Preis',
    description: 'Beschreibung',
    uploadVideo: 'Video hochladen',
    dragDropVideo: 'Video hierher ziehen oder klicken',
    sendViaWhatsApp: 'Per WhatsApp senden',
    sendViaEmail: 'Per E-Mail senden',
    productVideo: 'Produktvideo',
    videoTitle: 'Videotitel',
    videoDescription: 'Beschreibung',
    noVideos: 'Noch keine Videos',
    noProducts: 'Noch keine Produkte',
    
    // Mail Inbox
    inbox: 'Posteingang',
    sent: 'Gesendet',
    drafts: 'Entwürfe',
    starred: 'Markiert',
    trash: 'Papierkorb',
    spam: 'Spam',
    allMail: 'Alle E-Mails',
    compose: 'Neue E-Mail',
    from: 'Von',
    to: 'An',
    subject: 'Betreff',
    date: 'Datum',
    noEmails: 'Noch keine E-Mails',
    reply: 'Antworten',
    replyAll: 'Allen antworten',
    forward: 'Weiterleiten',
    markAsRead: 'Als gelesen markieren',
    markAsUnread: 'Als ungelesen markieren',
    moveTo: 'Verschieben nach',
    archive: 'Archivieren',
    refresh: 'Aktualisieren',
    attachment: 'Anhang',
    attachments: 'Anhänge',
    addAttachment: 'Anhang hinzufügen',
    sendNow: 'Jetzt senden',
    saveDraft: 'Entwurf speichern',
    discard: 'Verwerfen',
    cc: 'CC',
    bcc: 'BCC',
    unread: 'Ungelesen',
    important: 'Wichtig',
    // Mail Extended
    mailCenter: 'E-Mail-Zentrale',
    newMail: 'Neue E-Mail',
    signatureSettings: 'Signatur-Einstellungen',
    emailSettings: 'E-Mail-Einstellungen',
    connectionError: 'Verbindungsfehler',
    configureImap: 'Einstellungen → IMAP/SMTP konfigurieren',
    inboxEmpty: 'Ihr Posteingang ist leer',
    noSentMails: 'Noch keine E-Mails gesendet',
    noDrafts: 'Keine Entwürfe',
    noStarred: 'Keine markierten E-Mails',
    trashEmpty: 'Papierkorb ist leer',
    loadingMails: 'E-Mails werden geladen...',
    mailsUpdated: 'E-Mails aktualisiert',
    couldNotLoadMails: 'E-Mails konnten nicht geladen werden',
    movedToTrash: 'E-Mail in Papierkorb verschoben',
    signatureSaved: 'Signatur gespeichert',
    signatureNotSaved: 'Signatur konnte nicht gespeichert werden',
    settingsSaved: 'Einstellungen gespeichert',
    settingsNotSaved: 'Einstellungen konnten nicht gespeichert werden',
    recipientSubjectRequired: 'Empfänger und Betreff erforderlich',
    mailSent: 'E-Mail gesendet',
    mailServerUnavailable: 'Mail-Server vorübergehend nicht verfügbar. Als Entwurf gespeichert.',
    // AI Mail Features
    aiAssistant: 'KI-Assistent',
    aiSummaryAndReply: 'KI Zusammenfassung & Schnellantwort',
    analyzing: 'Analysieren...',
    quickReplies: 'Schnellantworten',
    translateToTr: 'Ins Türkische übersetzen',
    translateToEn: 'Ins Englische übersetzen',
    translateToDe: 'Ins Deutsche übersetzen',
    translation: 'Übersetzung',
    translating: 'Übersetzen...',
    translationFailed: 'Übersetzung fehlgeschlagen',
    aiHelper: 'KI-Helfer',
    writeWithAi: 'Mit KI schreiben',
    improve: 'Verbessern',
    shorten: 'Kürzen',
    expand: 'Erweitern',
    formalize: 'Formalisieren',
    whatToWrite: 'Was möchten Sie schreiben?',
    aiWriteHint: 'Z.B.: Schreiben Sie eine Entschuldigung für die Lieferverzögerung',
    tone: 'Ton',
    professional: 'Professionell',
    friendly: 'Freundlich',
    formal: 'Formell',
    generate: 'Erstellen',
    emailGenerated: 'E-Mail erstellt',
    couldNotGenerate: 'E-Mail konnte nicht erstellt werden',
    textImproved: 'Text verbessert',
    couldNotImprove: 'Verbesserung fehlgeschlagen',
    writeTextFirst: 'Schreiben Sie zuerst einen Text',
    specifyRequest: 'Bitte geben Sie an, was Sie schreiben möchten',
    addImage: 'Bild hinzufügen',
    imageHint: 'Sie können Logo oder Signaturbild hinzufügen',
    emailSignature: 'E-Mail-Signatur',
    senderInfo: 'Absenderinformationen',
    senderName: 'Absendername',
    senderEmail: 'Absender-E-Mail',
    imapSettings: 'IMAP-Einstellungen (Posteingang)',
    imapServer: 'IMAP-Server',
    imapPort: 'IMAP-Port',
    smtpSettings: 'SMTP-Einstellungen (Postausgang)',
    smtpServer: 'SMTP-Server',
    smtpPort: 'SMTP-Port',
    username: 'Benutzername',
    password: 'Passwort',
    settingsNote: 'IMAP/SMTP-Einstellungen erhalten Sie von Ihrem E-Mail-Anbieter (1&1 IONOS, Gmail usw.).',
    filesAdded: 'Dateien hinzugefügt',
    noSubject: '(Kein Betreff)',
    noContent: 'Kein Inhalt',
    loading: 'Wird geladen...',
    mail: 'E-Mail',
    replyMessage: 'Antworten',
    forwardMessage: 'Weiterleiten',
    newMessage: 'Neue Nachricht',
    // Pagination
    page: 'Seite',
    previous: 'Vorherige',
    next: 'Nächste',
    // Folders
    folders: 'Ordner',
    addFolder: 'Ordner hinzufügen',
    folderName: 'Ordnername',
    createFolder: 'Ordner erstellen',
    deleteFolder: 'Ordner löschen',
    customFolders: 'Benutzerdefinierte Ordner',
    // AI Analysis Features
    spamAnalysis: 'Spam-Analyse',
    customerRecognition: 'Kundenerkennung',
    sentimentAnalysis: 'Stimmungsanalyse',
    analyzingSpam: 'Spam-Prüfung...',
    notSpam: 'Kein Spam',
    possibleSpam: 'Möglicherweise Spam',
    definitelySpam: 'Definitiv Spam',
    recognizingCustomer: 'Kunde wird erkannt...',
    customerFound: 'Kunde gefunden',
    customerNotFound: 'Kunde nicht gefunden',
    analyzingSentiment: 'Stimmung wird analysiert...',
    positive: 'Positiv',
    negative: 'Negativ',
    neutral: 'Neutral',
    urgent: 'Dringend',
    fullScreen: 'Vollbild',
    exitFullScreen: 'Vollbild beenden',
    
    // Templates
    addTemplate: 'Vorlage hinzufügen',
    templateName: 'Vorlagenname',
    body: 'Inhalt',
    noTemplates: 'Noch keine Vorlagen',
    
    // Email Composer
    selectLead: 'Kunde auswählen',
    selectTemplate: 'Vorlage auswählen',
    generateWithAI: 'Mit KI erstellen',
    generating: 'Wird erstellt...',
    send: 'Senden',
    preview: 'Vorschau',
    emailSubject: 'E-Mail-Betreff',
    emailBody: 'E-Mail-Inhalt',
    tone: 'Ton',
    professional: 'Professionell',
    friendly: 'Freundlich',
    formal: 'Formell',
    
    // Email History
    recipient: 'Empfänger',
    company: 'Firma',
    status: 'Status',
    sentAt: 'Gesendet am',
    failed: 'Fehlgeschlagen',
    noEmailHistory: 'Noch kein E-Mail-Verlauf',
    
    // Settings
    companySettings: 'Firmeneinstellungen',
    smtpSettings: 'SMTP-Einstellungen',
    imapSettings: 'IMAP-Einstellungen',
    smtpHost: 'SMTP-Server',
    imapHost: 'IMAP-Server',
    smtpPort: 'SMTP-Port',
    imapPort: 'IMAP-Port',
    smtpUsername: 'Benutzername',
    smtpPassword: 'Passwort',
    fromEmail: 'Absender-E-Mail',
    fromName: 'Absendername',
    useTLS: 'TLS verwenden',
    useSSL: 'SSL verwenden',
    testConnection: 'Verbindung testen',
    saveSettings: 'Einstellungen speichern',
    
    // Orders
    order: 'Bestellung',
    orderDate: 'Bestelldatum',
    quantity: 'Menge',
    unitPrice: 'Stückpreis',
    pending: 'Ausstehend',
    confirmed: 'Bestätigt',
    shipped: 'Versendet',
    delivered: 'Geliefert',
    cancelled: 'Storniert',
    addOrder: 'Bestellung hinzufügen',
    editOrder: 'Bestellung bearbeiten',
    noOrders: 'Noch keine Bestellungen',
    
    // Shipments
    trackingNumber: 'Sendungsnummer',
    carrier: 'Spediteur',
    shipmentStatus: 'Sendungsstatus',
    addShipment: 'Sendung hinzufügen',
    noShipments: 'Noch keine Sendungen',
    trackShipment: 'Sendung verfolgen',
    
    // Recipes
    addRecipe: 'Rezept hinzufügen',
    recipeName: 'Rezeptname',
    ingredients: 'Zutaten',
    instructions: 'Anleitung',
    noRecipes: 'Noch keine Rezepte',
    
    // Specifications
    addSpecification: 'Spezifikation hinzufügen',
    noSpecifications: 'Noch keine Spezifikationen',
    
    // Daily Reports
    addReport: 'Bericht hinzufügen',
    reportDate: 'Berichtsdatum',
    reportContent: 'Berichtsinhalt',
    noReports: 'Noch keine Berichte',
    
    // Route Planner
    planRoute: 'Route planen',
    optimizeRoute: 'Route optimieren',
    startPoint: 'Startpunkt',
    endPoint: 'Endpunkt',
    waypoints: 'Zwischenstopps',
    
    // Lead Finder
    searchLeads: 'Kunden suchen',
    searchCountry: 'Land',
    searchCity: 'Stadt',
    businessType: 'Geschäftstyp',
    searchResults: 'Suchergebnisse',
    noResultsFound: 'Keine Ergebnisse gefunden',
    addToLeads: 'Zu Kunden hinzufügen',
    
    // Messages
    leadAdded: 'Kunde hinzugefügt',
    leadUpdated: 'Kunde aktualisiert',
    leadDeleted: 'Kunde gelöscht',
    templateAdded: 'Vorlage hinzugefügt',
    templateDeleted: 'Vorlage gelöscht',
    emailSent: 'E-Mail gesendet',
    emailQueued: 'E-Mail in Warteschlange',
    settingsSaved: 'Einstellungen gespeichert',
    connectionSuccess: 'Verbindung erfolgreich',
    connectionFailed: 'Verbindung fehlgeschlagen',
    error: 'Fehler',
    success: 'Erfolg',
    loading: 'Wird geladen...',
    search: 'Suchen',
    noResults: 'Keine Ergebnisse',
    
    // Common
    all: 'Alle',
    today: 'Heute',
    yesterday: 'Gestern',
    thisWeek: 'Diese Woche',
    thisMonth: 'Diesen Monat',
    download: 'Herunterladen',
    upload: 'Hochladen',
    share: 'Teilen',
    view: 'Ansehen',
    close: 'Schließen',
    back: 'Zurück',
    next: 'Weiter',
    previous: 'Vorherige',
    confirm: 'Bestätigen',
    yes: 'Ja',
    no: 'Nein',
    or: 'oder',
    and: 'und',
    of: 'von',
    items: 'Elemente',
    page: 'Seite',
    showing: 'Zeige',
    results: 'Ergebnisse',
    total: 'Gesamt',
    details: 'Details',
    information: 'Information',
    warning: 'Warnung',
    required: 'Erforderlich',
    optional: 'Optional',
    notConfigured: 'Nicht konfiguriert',
    configureNow: 'Jetzt konfigurieren',
    pleaseWait: 'Bitte warten...',
    somethingWentWrong: 'Etwas ist schiefgelaufen',
    tryAgain: 'Erneut versuchen',
    goBack: 'Zurück gehen',
  },
  en: {
    // Login
    welcome: 'Welcome',
    signInDescription: 'Sign in to access your CRM dashboard',
    username: 'Username',
    password: 'Password',
    enterUsername: 'Enter your username',
    enterPassword: 'Enter your password',
    signIn: 'Sign In',
    signingIn: 'Signing in...',
    
    // Navigation
    dashboard: 'Dashboard',
    leads: 'Leads',
    findLeads: 'Find Leads',
    orders: 'Orders',
    samples: 'Samples',
    shipments: 'Shipments',
    products: 'Products',
    productVideos: 'Product Videos',
    specifications: 'Specifications',
    recipes: 'Recipes',
    routePlanner: 'Route Planner',
    dailyReports: 'Daily Reports',
    expenses: 'Expenses & Invoices',
    foodFairs: 'Food Fairs',
    templates: 'Templates',
    mail: 'Gewürzberg Mail',
    gewuerzbergMail: 'Gewürzberg Mail',
    mailInbox: 'Gewürzberg Mail Inbox',
    aiMailComposer: 'AI Mail Composer',
    aiAnalytics: 'AI Analytics',
    customerSegments: 'Customer Segments',
    emailComposer: 'Compose Email',
    emailHistory: 'Email History',
    settings: 'Settings',
    admin: 'User Management',
    language: 'Language',
    logout: 'Logout',
    signature: 'Signature',
    
    // Dashboard
    totalLeads: 'Total Leads',
    customerDetails: 'Customer Details',
    totalOrders: 'Total Orders',
    emailsSent: 'Emails Sent',
    emailsFailed: 'Failed Emails',
    recentLeads: 'Recent Leads',
    noLeadsYet: 'No leads yet',
    recentShipments: 'Recent Shipments',
    welcomeTo: 'Welcome to',
    revenue: 'Revenue',
    yearlyTarget: 'Yearly Target',
    targetProgress: 'Target Progress',
    noTarget: 'No target set',
    calendar: 'Calendar',
    todaysAgenda: "Today's Agenda",
    noEventsToday: 'No events today',
    addEvent: 'Add Event',
    salesForecast: 'Sales Forecast',
    generateForecast: 'Generate Forecast',
    churnAnalysis: 'Churn Analysis',
    atRiskCustomers: 'At-Risk Customers',
    noAtRisk: 'No at-risk customers',
    analyzeChurn: 'Analyze Churn',
    allTime: 'All Time',
    oneMonth: '1 Month',
    threeMonths: '3 Months',
    sixMonths: '6 Months',
    oneYear: '1 Year',
    scheduleVisit: 'Schedule Visit',
    salesOverview: 'Sales Overview',
    customerHealth: 'Customer Health',
    quickActions: 'Quick Actions',
    newOrder: 'New Order',
    newLead: 'New Lead',
    sendMail: 'Send Mail',
    viewAll: 'View All',
    activeShipments: 'Active Shipments',
    pendingOrders: 'Pending Orders',
    thisMonth: 'This Month',
    lastMonth: 'Last Month',
    growth: 'Growth',
    healthy: 'Healthy',
    atRisk: 'At Risk',
    critical: 'Critical',
    title: 'Title',
    time: 'Time',
    customer: 'Customer',
    optional: 'Optional',
    selectCustomer: 'Select a customer...',
    noCustomer: 'No customer',
    additionalNotes: 'Additional notes...',
    pleaseEnterTitle: 'Please enter a title',
    recentShipments: 'Recent Shipments',
    topCustomers: 'Top Customers',
    financialSummary: 'Financial Summary',
    totalRevenue: 'Total Revenue',
    paid: 'Paid',
    pendingPayment: 'Pending',
    paymentRate: 'Payment Rate',
    annualTarget: 'Annual Target',
    completed: 'completed',
    predictedRevenue: 'Predicted Revenue',
    topFactor: 'Top Factor',
    recommendation: 'Recommendation',
    
    // Bulk Operations
    bulkEmail: 'Bulk Email',
    selected: 'Selected',
    sendingEmail: 'Sending...',
    addOrder: 'Add Order',
    searchOrders: 'Search orders...',
    noOrdersYet: 'No orders yet',
    selectCustomer: 'Select customer',
    orderNotes: 'Order notes...',
    donerNews: 'Döner & Kebab News',
    sendOrderByEmail: 'Send Order by Email',
    sendOrderEmailDescription: 'Send the order PDF to the desired email address',
    emailSubjectPlaceholder: 'Email subject',
    emailLanguage: 'Email Language',
    send: 'Send',
    cancel: 'Cancel',
    
    // Activity
    activityHistory: 'Activity History',
    newActivity: 'Add New Activity',
    allActivities: 'All conversations and visits',
    activityType: 'Activity Type',
    
    // Activity Types
    call: 'Call',
    visit: 'Visit',
    email: 'Email',
    order: 'Order',
    note: 'Note',
    followUp: 'Follow Up',
    sampleTested: 'Sample Tested',
    result: 'Result',
    positive: 'Positive',
    negative: 'Negative',
    neutral: 'Neutral',
    postponed: 'Postponed',
    noAnswer: 'No Answer',
    whatWasDiscussed: 'What was discussed?',
    nextActionDate: 'Next Action Date',
    nextActionNote: 'Next Action Note',
    whatToDo: 'What to do?',
    
    // Customer Status
    ordered: 'Ordered',
    pending: 'Pending',
    confirmed: 'Confirmed',
    
    // Admin
    addUser: 'Add User',
    editUser: 'Edit User',
    newUser: 'New User',
    user: 'User',
    users: 'users',
    enterUserInfo: 'Enter user information',
    fullName: 'Full Name',
    
    // Import/Export
    importToLeads: 'Import to Leads',
    addToLeads: 'Add Selected',
    
    // Event Types
    customerVisit: 'Customer Visit',
    meeting: 'Meeting',
    phoneCall: 'Phone Call',
    delivery: 'Delivery',
    task: 'Task',
    
    // Leads
    addLead: 'Add Lead',
    addNewLead: 'Add a new lead to your database',
    updateLeadInfo: 'Update lead information',
    editLead: 'Edit Lead',
    deleteLead: 'Delete Lead',
    firstName: 'First Name',
    lastName: 'Last Name',
    companyName: 'Company Name',
    taxNumber: 'Tax Number',
    address: 'Address',
    email: 'Email',
    phone: 'Phone',
    city: 'City',
    country: 'Country',
    notes: 'Notes',
    actions: 'Actions',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    sendEmail: 'Send Email',
    confirmDelete: 'Are you sure you want to delete this item?',
    viewDetails: 'View Details',
    downloadPdf: 'Download PDF',
    bulkEmail: 'Bulk Email',
    selectedItems: 'Selected Items',
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    
    // Products & Videos
    addProduct: 'Add Product',
    editProduct: 'Edit Product',
    productName: 'Product Name',
    productCode: 'Product Code',
    unit: 'Unit',
    price: 'Price',
    description: 'Description',
    uploadVideo: 'Upload Video',
    dragDropVideo: 'Drag and drop video here or click',
    sendViaWhatsApp: 'Send via WhatsApp',
    sendViaEmail: 'Send via Email',
    productVideo: 'Product Video',
    videoTitle: 'Video Title',
    videoDescription: 'Description',
    noVideos: 'No videos yet',
    noProducts: 'No products yet',
    
    // Mail Inbox
    inbox: 'Inbox',
    sent: 'Sent',
    drafts: 'Drafts',
    starred: 'Starred',
    trash: 'Trash',
    spam: 'Spam',
    allMail: 'All Mail',
    compose: 'Compose',
    from: 'From',
    to: 'To',
    subject: 'Subject',
    date: 'Date',
    noEmails: 'No emails yet',
    reply: 'Reply',
    replyAll: 'Reply All',
    forward: 'Forward',
    markAsRead: 'Mark as Read',
    markAsUnread: 'Mark as Unread',
    moveTo: 'Move to',
    archive: 'Archive',
    refresh: 'Refresh',
    attachment: 'Attachment',
    attachments: 'Attachments',
    addAttachment: 'Add Attachment',
    sendNow: 'Send Now',
    saveDraft: 'Save Draft',
    discard: 'Discard',
    cc: 'CC',
    bcc: 'BCC',
    unread: 'Unread',
    important: 'Important',
    // Mail Extended
    mailCenter: 'E-Mail Center',
    newMail: 'New Mail',
    signatureSettings: 'Signature Settings',
    emailSettings: 'Email Settings',
    connectionError: 'Connection Error',
    configureImap: 'Settings → Configure IMAP/SMTP',
    inboxEmpty: 'Your inbox is empty',
    noSentMails: 'No emails sent yet',
    noDrafts: 'No drafts',
    noStarred: 'No starred emails',
    trashEmpty: 'Trash is empty',
    loadingMails: 'Loading emails...',
    mailsUpdated: 'Emails updated',
    couldNotLoadMails: 'Could not load emails',
    movedToTrash: 'Email moved to trash',
    signatureSaved: 'Signature saved',
    signatureNotSaved: 'Could not save signature',
    settingsSaved: 'Settings saved',
    settingsNotSaved: 'Could not save settings',
    recipientSubjectRequired: 'Recipient and subject required',
    mailSent: 'Email sent',
    mailServerUnavailable: 'Mail server temporarily unavailable. Saved as draft.',
    // AI Mail Features
    aiAssistant: 'AI Assistant',
    aiSummaryAndReply: 'AI Summary & Quick Reply',
    analyzing: 'Analyzing...',
    quickReplies: 'Quick Replies',
    translateToTr: 'Translate to Turkish',
    translateToEn: 'Translate to English',
    translateToDe: 'Translate to German',
    translation: 'Translation',
    translating: 'Translating...',
    translationFailed: 'Translation failed',
    aiHelper: 'AI Helper',
    writeWithAi: 'Write with AI',
    improve: 'Improve',
    shorten: 'Shorten',
    expand: 'Expand',
    formalize: 'Formalize',
    whatToWrite: 'What do you want to write?',
    aiWriteHint: 'E.g.: Write an apology email for order delay',
    tone: 'Tone',
    professional: 'Professional',
    friendly: 'Friendly',
    formal: 'Formal',
    generate: 'Generate',
    emailGenerated: 'Email generated',
    couldNotGenerate: 'Could not generate email',
    textImproved: 'Text improved',
    couldNotImprove: 'Could not improve',
    writeTextFirst: 'Write some text first',
    specifyRequest: 'Please specify what you want to write',
    addImage: 'Add Image',
    imageHint: 'You can add logo or signature image',
    emailSignature: 'Email Signature',
    senderInfo: 'Sender Information',
    senderName: 'Sender Name',
    senderEmail: 'Sender Email',
    imapSettings: 'IMAP Settings (Inbox)',
    imapServer: 'IMAP Server',
    imapPort: 'IMAP Port',
    smtpSettings: 'SMTP Settings (Outbox)',
    smtpServer: 'SMTP Server',
    smtpPort: 'SMTP Port',
    username: 'Username',
    password: 'Password',
    settingsNote: 'Get IMAP/SMTP settings from your email provider (1&1 IONOS, Gmail, etc.).',
    filesAdded: 'files added',
    noSubject: '(No Subject)',
    noContent: 'No content',
    loading: 'Loading...',
    mail: 'email',
    replyMessage: 'Reply',
    forwardMessage: 'Forward',
    newMessage: 'New Message',
    // Pagination
    page: 'Page',
    previous: 'Previous',
    next: 'Next',
    // Folders
    folders: 'Folders',
    addFolder: 'Add Folder',
    folderName: 'Folder Name',
    createFolder: 'Create Folder',
    deleteFolder: 'Delete Folder',
    customFolders: 'Custom Folders',
    // AI Analysis Features
    spamAnalysis: 'Spam Analysis',
    customerRecognition: 'Customer Recognition',
    sentimentAnalysis: 'Sentiment Analysis',
    analyzingSpam: 'Checking for spam...',
    notSpam: 'Not spam',
    possibleSpam: 'Possible spam',
    definitelySpam: 'Definitely spam',
    recognizingCustomer: 'Recognizing customer...',
    customerFound: 'Customer found',
    customerNotFound: 'Customer not found',
    analyzingSentiment: 'Analyzing sentiment...',
    positive: 'Positive',
    negative: 'Negative',
    neutral: 'Neutral',
    urgent: 'Urgent',
    fullScreen: 'Full Screen',
    exitFullScreen: 'Exit Full Screen',
    
    // Templates
    addTemplate: 'Add Template',
    templateName: 'Template Name',
    body: 'Body',
    noTemplates: 'No templates yet',
    
    // Email Composer
    selectLead: 'Select Lead',
    selectTemplate: 'Select Template',
    generateWithAI: 'Generate with AI',
    generating: 'Generating...',
    send: 'Send',
    preview: 'Preview',
    emailSubject: 'Email Subject',
    emailBody: 'Email Body',
    tone: 'Tone',
    professional: 'Professional',
    friendly: 'Friendly',
    formal: 'Formal',
    
    // Email History
    recipient: 'Recipient',
    company: 'Company',
    status: 'Status',
    sentAt: 'Sent At',
    failed: 'Failed',
    noEmailHistory: 'No email history yet',
    
    // Settings
    companySettings: 'Company Settings',
    smtpSettings: 'SMTP Settings',
    imapSettings: 'IMAP Settings',
    smtpHost: 'SMTP Host',
    imapHost: 'IMAP Host',
    smtpPort: 'SMTP Port',
    imapPort: 'IMAP Port',
    smtpUsername: 'Username',
    smtpPassword: 'Password',
    fromEmail: 'From Email',
    fromName: 'From Name',
    useTLS: 'Use TLS',
    useSSL: 'Use SSL',
    testConnection: 'Test Connection',
    saveSettings: 'Save Settings',
    
    // Orders
    order: 'Order',
    orderDate: 'Order Date',
    quantity: 'Quantity',
    unitPrice: 'Unit Price',
    pending: 'Pending',
    confirmed: 'Confirmed',
    shipped: 'Shipped',
    delivered: 'Delivered',
    cancelled: 'Cancelled',
    addOrder: 'Add Order',
    editOrder: 'Edit Order',
    noOrders: 'No orders yet',
    
    // Shipments
    trackingNumber: 'Tracking Number',
    carrier: 'Carrier',
    shipmentStatus: 'Shipment Status',
    addShipment: 'Add Shipment',
    noShipments: 'No shipments yet',
    trackShipment: 'Track Shipment',
    
    // Recipes
    addRecipe: 'Add Recipe',
    recipeName: 'Recipe Name',
    ingredients: 'Ingredients',
    instructions: 'Instructions',
    noRecipes: 'No recipes yet',
    
    // Specifications
    addSpecification: 'Add Specification',
    noSpecifications: 'No specifications yet',
    
    // Daily Reports
    addReport: 'Add Report',
    reportDate: 'Report Date',
    reportContent: 'Report Content',
    noReports: 'No reports yet',
    
    // Expenses & Invoices
    expensesTitle: 'Expenses & Invoices',
    newFolder: 'New Folder',
    excel: 'Excel',
    report: 'Report',
    monthlyReport: 'Monthly Report',
    yearlyReport: 'Yearly Report',
    allExpenses: 'All Expenses',
    mergePdf: 'Merge PDFs',
    scanInvoice: 'Scan Invoice',
    uploadPdf: 'Upload PDF',
    noExpenses: 'No expenses yet',
    dragDropPdf: 'Drag and drop PDF files or click upload',
    totalExpense: 'Total Expense',
    hotel: 'Hotel',
    creditCard: 'Credit Card',
    dkv: 'DKV',
    otherExpenses: 'Other Expenses',
    allFolders: 'All',
    backFolder: 'Back',
    enterFolder: 'Enter Folder',
    deleteFolder: 'Delete',
    moveToFolder: 'Move to Folder',
    selectFolder: 'Select Folder',
    category: 'Category',
    description: 'Description',
    amount: 'Amount',
    date: 'Date',
    country: 'Country',
    address: 'Address',
    notes: 'Notes',
    checkIn: 'Check-In',
    checkOut: 'Check-Out',
    nights: 'Nights',
    preview: 'Preview',
    excelDownloaded: 'Excel downloaded',
    reportDownloaded: 'Report downloaded',
    pdfsMerged: 'PDFs merged',
    invoiceScanned: 'Invoice scanned successfully',
    allMonths: 'All Months',
    allCategories: 'All Categories',
    
    // Route Planner
    planRoute: 'Plan Route',
    optimizeRoute: 'Optimize Route',
    startPoint: 'Start Point',
    endPoint: 'End Point',
    waypoints: 'Waypoints',
    
    // Lead Finder
    searchLeads: 'Search Leads',
    searchCountry: 'Country',
    searchCity: 'City',
    businessType: 'Business Type',
    searchResults: 'Search Results',
    noResultsFound: 'No results found',
    addToLeads: 'Add to Leads',
    
    // Messages
    leadAdded: 'Lead added',
    leadUpdated: 'Lead updated',
    leadDeleted: 'Lead deleted',
    templateAdded: 'Template added',
    templateDeleted: 'Template deleted',
    emailSent: 'Email sent',
    emailQueued: 'Email queued',
    settingsSaved: 'Settings saved',
    connectionSuccess: 'Connection successful',
    connectionFailed: 'Connection failed',
    error: 'Error',
    success: 'Success',
    loading: 'Loading...',
    search: 'Search',
    noResults: 'No results found',
    
    // Common
    all: 'All',
    today: 'Today',
    yesterday: 'Yesterday',
    thisWeek: 'This Week',
    thisMonth: 'This Month',
    download: 'Download',
    upload: 'Upload',
    share: 'Share',
    view: 'View',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    or: 'or',
    and: 'and',
    of: 'of',
    items: 'items',
    page: 'Page',
    showing: 'Showing',
    results: 'results',
    total: 'Total',
    details: 'Details',
    information: 'Information',
    warning: 'Warning',
    required: 'Required',
    optional: 'Optional',
    notConfigured: 'Not configured',
    configureNow: 'Configure now',
    pleaseWait: 'Please wait...',
    somethingWentWrong: 'Something went wrong',
    tryAgain: 'Try again',
    goBack: 'Go back',
  },
  pl: {
    // Login
    welcome: 'Witamy',
    signInDescription: 'Zaloguj się, aby uzyskać dostęp do panelu CRM',
    username: 'Nazwa użytkownika',
    password: 'Hasło',
    enterUsername: 'Wprowadź nazwę użytkownika',
    enterPassword: 'Wprowadź hasło',
    signIn: 'Zaloguj się',
    signingIn: 'Logowanie...',
    
    // Navigation - Polish
    dashboard: 'Panel sterowania',
    leads: 'Klienci',
    findLeads: 'Znajdź klientów',
    orders: 'Zamówienia',
    samples: 'Próbki',
    shipments: 'Śledzenie przesyłek',
    products: 'Produkty',
    productVideos: 'Filmy produktowe',
    specifications: 'Specyfikacje',
    recipes: 'Receptury',
    routePlanner: 'Planowanie trasy',
    dailyReports: 'Raporty dzienne',
    expenses: 'Wydatki i Faktury',
    foodFairs: 'Targi Spożywcze',
    templates: 'Szablony',
    mail: 'Gewürzberg Poczta',
    gewuerzbergMail: 'Gewürzberg Mail',
    mailInbox: 'Gewürzberg Skrzynka',
    aiMailComposer: 'AI kompozytor',
    aiAnalytics: 'Analiza AI',
    customerSegments: 'Segmenty klientów',
    emailComposer: 'Napisz e-mail',
    emailHistory: 'Historia e-mail',
    settings: 'Ustawienia',
    admin: 'Zarządzanie użytkownikami',
    language: 'Język',
    logout: 'Wyloguj',
    signature: 'Podpis',
    
    // Dashboard
    totalLeads: 'Łączna liczba klientów',
    customerDetails: 'Szczegóły klienta',
    totalOrders: 'Łączna liczba zamówień',
    emailsSent: 'Wysłane e-maile',
    emailsFailed: 'Nieudane e-maile',
    recentLeads: 'Ostatnio dodani klienci',
    noLeadsYet: 'Brak klientów',
    recentShipments: 'Ostatnie przesyłki',
    welcomeTo: 'Witamy w',
    revenue: 'Przychody',
    yearlyTarget: 'Cel roczny',
    targetProgress: 'Postęp celu',
    noTarget: 'Brak wyznaczonego celu',
    calendar: 'Kalendarz',
    todaysAgenda: 'Dzisiejsza agenda',
    noEventsToday: 'Brak wydarzeń na dziś',
    addEvent: 'Dodaj wydarzenie',
    salesForecast: 'Prognoza sprzedaży',
    generateForecast: 'Generuj prognozę',
    churnAnalysis: 'Analiza rezygnacji',
    atRiskCustomers: 'Zagrożeni klienci',
    noAtRisk: 'Brak zagrożonych klientów',
    analyzeChurn: 'Analizuj rezygnacje',
    allTime: 'Cały czas',
    oneMonth: '1 miesiąc',
    threeMonths: '3 miesiące',
    sixMonths: '6 miesięcy',
    oneYear: '1 rok',
    scheduleVisit: 'Zaplanuj wizytę',
    salesOverview: 'Przegląd sprzedaży',
    customerHealth: 'Status klienta',
    quickActions: 'Szybkie akcje',
    newOrder: 'Nowe zamówienie',
    newLead: 'Nowy klient',
    sendMail: 'Wyślij e-mail',
    viewAll: 'Zobacz wszystko',
    activeShipments: 'Aktywne przesyłki',
    pendingOrders: 'Oczekujące zamówienia',
    thisMonth: 'Ten miesiąc',
    lastMonth: 'Poprzedni miesiąc',
    growth: 'Wzrost',
    healthy: 'Zdrowy',
    atRisk: 'Zagrożony',
    critical: 'Krytyczny',
    title: 'Tytuł',
    time: 'Czas',
    customer: 'Klient',
    optional: 'Opcjonalny',
    selectCustomer: 'Wybierz klienta...',
    noCustomer: 'Brak klienta',
    additionalNotes: 'Dodatkowe notatki...',
    pleaseEnterTitle: 'Proszę wprowadzić tytuł',
    recentShipments: 'Ostatnie przesyłki',
    topCustomers: 'Najlepsi klienci',
    financialSummary: 'Podsumowanie finansowe',
    totalRevenue: 'Całkowity przychód',
    paid: 'Opłacone',
    pendingPayment: 'Oczekujące',
    paymentRate: 'Wskaźnik płatności',
    annualTarget: 'Cel roczny',
    completed: 'ukończono',
    predictedRevenue: 'Przewidywany przychód',
    topFactor: 'Główny czynnik',
    recommendation: 'Zalecenie',
    
    // Bulk Operations
    bulkEmail: 'Masowy e-mail',
    selected: 'Wybrano',
    sendingEmail: 'Wysyłanie...',
    addOrder: 'Dodaj zamówienie',
    searchOrders: 'Szukaj zamówień...',
    noOrdersYet: 'Brak zamówień',
    selectCustomer: 'Wybierz klienta',
    orderNotes: 'Notatki do zamówienia...',
    donerNews: 'Wiadomości o Döner & Kebab',
    sendOrderByEmail: 'Wyślij zamówienie e-mailem',
    sendOrderEmailDescription: 'Wyślij PDF zamówienia na podany adres e-mail',
    emailSubjectPlaceholder: 'Temat e-maila',
    emailLanguage: 'Język e-maila',
    send: 'Wyślij',
    cancel: 'Anuluj',
    
    // Activity
    activityHistory: 'Historia aktywności',
    newActivity: 'Dodaj nową aktywność',
    allActivities: 'Wszystkie rozmowy i wizyty',
    activityType: 'Typ aktywności',
    
    // Activity Types
    call: 'Telefon',
    visit: 'Wizyta',
    email: 'E-mail',
    order: 'Zamówienie',
    note: 'Notatka',
    followUp: 'Kontynuacja',
    sampleTested: 'Próbka Przetestowana',
    result: 'Wynik',
    positive: 'Pozytywny',
    negative: 'Negatywny',
    neutral: 'Neutralny',
    postponed: 'Przełożono',
    noAnswer: 'Brak odpowiedzi',
    whatWasDiscussed: 'Co zostało omówione?',
    nextActionDate: 'Data następnej akcji',
    nextActionNote: 'Notatka następnej akcji',
    whatToDo: 'Co zrobić?',
    
    // Customer Status
    ordered: 'Zamówiono',
    pending: 'Oczekujące',
    confirmed: 'Potwierdzone',
    
    // Admin
    addUser: 'Dodaj użytkownika',
    editUser: 'Edytuj użytkownika',
    newUser: 'Nowy użytkownik',
    user: 'Użytkownik',
    users: 'użytkownicy',
    enterUserInfo: 'Wprowadź informacje o użytkowniku',
    fullName: 'Imię i nazwisko',
    
    // Import/Export
    importToLeads: 'Importuj do klientów',
    addToLeads: 'Dodaj wybrane',
    
    // Event Types
    customerVisit: 'Wizyta u klienta',
    meeting: 'Spotkanie',
    phoneCall: 'Rozmowa telefoniczna',
    delivery: 'Dostawa',
    task: 'Zadanie',
    
    // Leads
    addLead: 'Dodaj klienta',
    addNewLead: 'Dodaj nowego klienta do bazy danych',
    updateLeadInfo: 'Zaktualizuj informacje o kliencie',
    editLead: 'Edytuj klienta',
    deleteLead: 'Usuń klienta',
    firstName: 'Imię',
    lastName: 'Nazwisko',
    companyName: 'Nazwa firmy',
    taxNumber: 'NIP',
    address: 'Adres',
    email: 'E-mail',
    phone: 'Telefon',
    city: 'Miasto',
    country: 'Kraj',
    notes: 'Notatki',
    actions: 'Akcje',
    save: 'Zapisz',
    cancel: 'Anuluj',
    delete: 'Usuń',
    edit: 'Edytuj',
    sendEmail: 'Wyślij e-mail',
    confirmDelete: 'Czy na pewno chcesz usunąć ten element?',
    viewDetails: 'Zobacz szczegóły',
    downloadPdf: 'Pobierz PDF',
    bulkEmail: 'E-mail masowy',
    selectedItems: 'Wybrane elementy',
    selectAll: 'Zaznacz wszystko',
    deselectAll: 'Odznacz wszystko',
    
    // Products & Videos
    addProduct: 'Dodaj produkt',
    editProduct: 'Edytuj produkt',
    productName: 'Nazwa produktu',
    productCode: 'Kod produktu',
    unit: 'Jednostka',
    price: 'Cena',
    description: 'Opis',
    uploadVideo: 'Prześlij wideo',
    dragDropVideo: 'Przeciągnij i upuść wideo tutaj lub kliknij',
    sendViaWhatsApp: 'Wyślij przez WhatsApp',
    sendViaEmail: 'Wyślij e-mailem',
    productVideo: 'Film produktowy',
    videoTitle: 'Tytuł wideo',
    videoDescription: 'Opis',
    noVideos: 'Brak filmów',
    noProducts: 'Brak produktów',
    
    // Mail Inbox
    inbox: 'Skrzynka odbiorcza',
    sent: 'Wysłane',
    drafts: 'Szkice',
    starred: 'Oznaczone',
    trash: 'Kosz',
    spam: 'Spam',
    allMail: 'Wszystkie e-maile',
    compose: 'Nowy e-mail',
    from: 'Od',
    to: 'Do',
    subject: 'Temat',
    date: 'Data',
    noEmails: 'Brak e-maili',
    reply: 'Odpowiedz',
    replyAll: 'Odpowiedz wszystkim',
    forward: 'Przekaż',
    markAsRead: 'Oznacz jako przeczytane',
    markAsUnread: 'Oznacz jako nieprzeczytane',
    moveTo: 'Przenieś do',
    archive: 'Archiwizuj',
    refresh: 'Odśwież',
    attachment: 'Załącznik',
    attachments: 'Załączniki',
    addAttachment: 'Dodaj załącznik',
    sendNow: 'Wyślij teraz',
    saveDraft: 'Zapisz szkic',
    discard: 'Odrzuć',
    cc: 'DW',
    bcc: 'UDW',
    unread: 'Nieprzeczytane',
    important: 'Ważne',
    
    // Templates
    addTemplate: 'Dodaj szablon',
    templateName: 'Nazwa szablonu',
    body: 'Treść',
    noTemplates: 'Brak szablonów',
    
    // Email Composer
    selectLead: 'Wybierz klienta',
    selectTemplate: 'Wybierz szablon',
    generateWithAI: 'Generuj z AI',
    generating: 'Generowanie...',
    send: 'Wyślij',
    preview: 'Podgląd',
    emailSubject: 'Temat e-mail',
    emailBody: 'Treść e-mail',
    tone: 'Ton',
    professional: 'Profesjonalny',
    friendly: 'Przyjazny',
    formal: 'Formalny',
    
    // Email History
    recipient: 'Odbiorca',
    company: 'Firma',
    status: 'Status',
    sentAt: 'Wysłano',
    failed: 'Nieudane',
    noEmailHistory: 'Brak historii e-mail',
    
    // Settings
    companySettings: 'Ustawienia firmy',
    smtpSettings: 'Ustawienia SMTP',
    imapSettings: 'Ustawienia IMAP',
    smtpHost: 'Serwer SMTP',
    imapHost: 'Serwer IMAP',
    smtpPort: 'Port SMTP',
    imapPort: 'Port IMAP',
    smtpUsername: 'Nazwa użytkownika',
    smtpPassword: 'Hasło',
    fromEmail: 'E-mail nadawcy',
    fromName: 'Nazwa nadawcy',
    useTLS: 'Użyj TLS',
    useSSL: 'Użyj SSL',
    testConnection: 'Testuj połączenie',
    saveSettings: 'Zapisz ustawienia',
    
    // Orders
    order: 'Zamówienie',
    orderDate: 'Data zamówienia',
    quantity: 'Ilość',
    unitPrice: 'Cena jednostkowa',
    pending: 'Oczekujące',
    confirmed: 'Potwierdzone',
    shipped: 'Wysłane',
    delivered: 'Dostarczone',
    cancelled: 'Anulowane',
    addOrder: 'Dodaj zamówienie',
    editOrder: 'Edytuj zamówienie',
    noOrders: 'Brak zamówień',
    
    // Shipments
    trackingNumber: 'Numer śledzenia',
    carrier: 'Przewoźnik',
    shipmentStatus: 'Status przesyłki',
    addShipment: 'Dodaj przesyłkę',
    noShipments: 'Brak przesyłek',
    trackShipment: 'Śledź przesyłkę',
    
    // Recipes
    addRecipe: 'Dodaj recepturę',
    recipeName: 'Nazwa receptury',
    ingredients: 'Składniki',
    instructions: 'Instrukcje',
    noRecipes: 'Brak receptur',
    
    // Specifications
    addSpecification: 'Dodaj specyfikację',
    noSpecifications: 'Brak specyfikacji',
    
    // Daily Reports
    addReport: 'Dodaj raport',
    reportDate: 'Data raportu',
    reportContent: 'Treść raportu',
    noReports: 'Brak raportów',
    
    // Route Planner
    planRoute: 'Zaplanuj trasę',
    optimizeRoute: 'Optymalizuj trasę',
    startPoint: 'Punkt startowy',
    endPoint: 'Punkt docelowy',
    waypoints: 'Punkty pośrednie',
    
    // Lead Finder
    searchLeads: 'Szukaj klientów',
    searchCountry: 'Kraj',
    searchCity: 'Miasto',
    businessType: 'Typ działalności',
    searchResults: 'Wyniki wyszukiwania',
    noResultsFound: 'Nie znaleziono wyników',
    addToLeads: 'Dodaj do klientów',
    
    // Messages
    leadAdded: 'Klient dodany',
    leadUpdated: 'Klient zaktualizowany',
    leadDeleted: 'Klient usunięty',
    templateAdded: 'Szablon dodany',
    templateDeleted: 'Szablon usunięty',
    emailSent: 'E-mail wysłany',
    emailQueued: 'E-mail w kolejce',
    settingsSaved: 'Ustawienia zapisane',
    connectionSuccess: 'Połączenie udane',
    connectionFailed: 'Połączenie nieudane',
    error: 'Błąd',
    success: 'Sukces',
    loading: 'Ładowanie...',
    search: 'Szukaj',
    noResults: 'Brak wyników',
    
    // Common
    all: 'Wszystko',
    today: 'Dziś',
    yesterday: 'Wczoraj',
    thisWeek: 'Ten tydzień',
    thisMonth: 'Ten miesiąc',
    download: 'Pobierz',
    upload: 'Prześlij',
    share: 'Udostępnij',
    view: 'Zobacz',
    close: 'Zamknij',
    back: 'Wstecz',
    next: 'Dalej',
    previous: 'Poprzedni',
    confirm: 'Potwierdź',
    yes: 'Tak',
    no: 'Nie',
    or: 'lub',
    and: 'i',
    of: 'z',
    items: 'elementów',
    page: 'Strona',
    showing: 'Pokazuje',
    results: 'wyników',
    total: 'Razem',
    details: 'Szczegóły',
    information: 'Informacja',
    warning: 'Ostrzeżenie',
    required: 'Wymagane',
    optional: 'Opcjonalne',
    notConfigured: 'Nie skonfigurowano',
    configureNow: 'Skonfiguruj teraz',
    pleaseWait: 'Proszę czekać...',
    somethingWentWrong: 'Coś poszło nie tak',
    tryAgain: 'Spróbuj ponownie',
    goBack: 'Wróć',
  },
  
  // Greek translations
  el: {
    // Login
    welcome: 'Καλώς ήρθατε',
    signInDescription: 'Συνδεθείτε για πρόσβαση στο CRM',
    username: 'Όνομα χρήστη',
    password: 'Κωδικός',
    enterUsername: 'Εισάγετε το όνομα χρήστη',
    enterPassword: 'Εισάγετε τον κωδικό',
    signIn: 'Σύνδεση',
    signingIn: 'Σύνδεση...',
    
    // Navigation
    dashboard: 'Πίνακας ελέγχου',
    leads: 'Πελάτες',
    mail: 'Email',
    settings: 'Ρυθμίσεις',
    logout: 'Αποσύνδεση',
    foodFairs: 'Εκθέσεις Τροφίμων',
    
    // Mail
    inbox: 'Εισερχόμενα',
    sent: 'Απεσταλμένα',
    drafts: 'Πρόχειρα',
    starred: 'Με αστέρι',
    trash: 'Κάδος',
    compose: 'Νέο μήνυμα',
    from: 'Από',
    to: 'Προς',
    subject: 'Θέμα',
    send: 'Αποστολή',
    reply: 'Απάντηση',
    forward: 'Προώθηση',
    attachments: 'Συνημμένα',
    noEmails: 'Δεν υπάρχουν email',
    loading: 'Φόρτωση...',
    page: 'Σελίδα',
    previous: 'Προηγούμενη',
    next: 'Επόμενη',
    
    // AI Features
    aiAssistant: 'AI Βοηθός',
    aiSummaryAndReply: 'AI Σύνοψη & Απάντηση',
    spamAnalysis: 'Ανάλυση Spam',
    customerRecognition: 'Αναγνώριση Πελάτη',
    sentimentAnalysis: 'Ανάλυση Συναισθημάτων',
    analyzing: 'Ανάλυση...',
    
    // Common
    save: 'Αποθήκευση',
    cancel: 'Ακύρωση',
    delete: 'Διαγραφή',
    edit: 'Επεξεργασία',
    search: 'Αναζήτηση',
    error: 'Σφάλμα',
    success: 'Επιτυχία',
  },
  
  // Bulgarian translations
  bg: {
    // Login
    welcome: 'Добре дошли',
    signInDescription: 'Влезте за достъп до CRM',
    username: 'Потребителско име',
    password: 'Парола',
    enterUsername: 'Въведете потребителско име',
    enterPassword: 'Въведете парола',
    signIn: 'Вход',
    signingIn: 'Влизане...',
    
    // Navigation
    dashboard: 'Табло',
    leads: 'Клиенти',
    mail: 'Имейл',
    settings: 'Настройки',
    logout: 'Изход',
    foodFairs: 'Хранителни изложения',
    
    // Mail
    inbox: 'Входящи',
    sent: 'Изпратени',
    drafts: 'Чернови',
    starred: 'Със звезда',
    trash: 'Кошче',
    compose: 'Ново съобщение',
    from: 'От',
    to: 'До',
    subject: 'Тема',
    send: 'Изпрати',
    reply: 'Отговор',
    forward: 'Препрати',
    attachments: 'Прикачени',
    noEmails: 'Няма имейли',
    loading: 'Зареждане...',
    page: 'Страница',
    previous: 'Предишна',
    next: 'Следваща',
    
    // AI Features
    aiAssistant: 'AI Асистент',
    aiSummaryAndReply: 'AI Резюме & Отговор',
    spamAnalysis: 'Анализ на спам',
    customerRecognition: 'Разпознаване на клиент',
    sentimentAnalysis: 'Анализ на настроения',
    analyzing: 'Анализиране...',
    
    // Common
    save: 'Запази',
    cancel: 'Отказ',
    delete: 'Изтрий',
    edit: 'Редактирай',
    search: 'Търсене',
    error: 'Грешка',
    success: 'Успех',
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  // Load language from localStorage or default to Turkish
  const [language, setLanguageState] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('app_language') || 'tr';
    }
    return 'tr';
  });
  
  // Persist language to localStorage when it changes
  const setLanguage = useCallback((lang) => {
    setLanguageState(lang);
    if (typeof window !== 'undefined') {
      localStorage.setItem('app_language', lang);
    }
  }, []);
  
  const t = useCallback((key) => {
    return translations[language]?.[key] || translations['en']?.[key] || key;
  }, [language]);
  
  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, translations }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
